import React from "react";
import BackpackOutlinedIcon from "@mui/icons-material/BackpackOutlined";
const PackagesIcon = () => {
  return <BackpackOutlinedIcon sx={{ fill: "white" }} />;
};

export default PackagesIcon;
